import { render, staticRenderFns } from "./aiChat.vue?vue&type=template&id=391a7065&scoped=true&"
import script from "./aiChat.vue?vue&type=script&lang=js&"
export * from "./aiChat.vue?vue&type=script&lang=js&"
import style0 from "./aiChat.vue?vue&type=style&index=0&id=391a7065&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391a7065",
  null
  
)

export default component.exports